import React from "react"
import {CustomLoginWrapper} from './style.jsx'
import {isApplyCustomLayout} from '../const.js'
const CustomLogin = ({children}) => {
  return <CustomLoginWrapper isApplyCustomLayout={isApplyCustomLayout}>{children}</CustomLoginWrapper>
}
export default CustomLogin



// WEBPACK FOOTER //
// ./src/common/custom-layout/CustomLoginWrapper/index.js